export const getEndpoint = (path: string): string => {
  return window.location.hostname === "localhost" ? `/api${path}` : `${path}`;
};
